import languages from '../languages';
languages.init();

export default function () {
  return languages.mapMutiples([
    'payMall',
    'payCenter',
    'selectPayment',
    'gainPlus',
    'plzSelectPayWay',
    'gainMorePlus',
    'gainMostPlus',
    'creatework_server',
    'roleName',
    'payWay',
    'plzSelectOtherWay',
    'payment',
    'compensateTips',
    'extaGain',
    'gameGold',
    'compensate',
    'payWayPlus',
    'neddPay',
    'submitOrder',
    'screenshotTips',
    'storeSuccess',
    'storeFail',
    'storeAcceptance',
    'storeSuccessTips',
    'storeFailTips',
    'orderNumber',
    'creatework_game',
    'buyProduct',
    'transactionAmount',
    'failReason',
    'payOntherORder',
    'mywork_goGame',
    'contactService',
    'reStore',
    'creatework_goGame',
    'plzSelectPayType',
    'browserPayErrBtnText',
    'browserPaySucBtnText',
    'browserPayingTips',
    'price_list_empty',
    'pointCardTips',
    'mywork_confirm',
    'willGet',
    'goods',
    'discount',
    'payDiscount',
    'payDiscountTips',
    'hasQuestionPlease',
    'payWayPlusC',
    'payReward',
    'hasEqualReward',
    'hasEqualRewardMuglo',
    'payBtnText',
    'payBtn',
    'storeHoaveReward',
    'showMorePayWay',
    'needPaymentCount',
    'orderDetail',
    'selectPayWayPlz',
    'region',
    'store_product_paytype_error',
    'tips',
    'cancel',
    'confirm',
    'and',
    'lastSelectTag',
    'jiamaInfo',
    'quickcard_tips',
    'quickcard_use_new_card',
    'edit',
    'save',
    'quickcard_confirm_delete',
    'quickcard_popup_tip',
    'quickcard_result_tip_one',
    'quickcard_result_tip_two',
    'quickcard_learn_more',
    'quickcard_info_title',
    'quickcard_info_tip_one',
    'quickcard_info_tip_two',
    'useDoubleSend',
    'doubleSendInfo',
    'couponCanUse',
    'couponCanNotUse',
    'couponHasNoCoupon',
    'couponUseTip',
    'couponValidTime',
    'couponFuilCanUse',
    'couponNoLimit',
    'couponAllProductCanUse',
    'couponPartProductCanUse',
    'couponPartPaytypeCanUse',
    'couponOnlyCoinCanUse',
    'couponOnlyDiamondCanUse',
    'couponOnlyPackageCanUse',
    'couponOnlySubCanUse',
    'couponOnlyDaibiCanUse',
    'couponMaxDiscount',
    'couponHasUsed',
    'couponReductionType',
    'couponDiscountType',
    'couponUseNow',
    'couponHasNoSelect',
    'couponHasSelectQuan',
    'couponSubmitTip',
    'couponCanUseQuan',
    'couponOrderTotal',
    'couponHasDiscount',
    'couponPayTotal',
    'couponCancel',
    'couponConfirm',
    'couponCoupon',
    'couponNoUse',
    'couponSelect',
    'couponSureUse',
    'couponReturn',
    'couponInvalidTime',
    'dl3dvnVipRule1',
    'dl3dvnVipRule2',
    'dl3dvnVipRule3',
    'dl3dvnVipRule4',
    'dl3dvnVipRule5',
    'dl3dvnVipRule6',
    'dl3dvnVipRule7',
    'dl3dvnVipRule8',
    'dl3dvnVipRule9',
    'dl3dvnVipRule10',
    'dl3dvnVipRule11',
    'dl3dvnVipRule12',
    'dl3dvnVipRule13',
    'lastAllCoupon',
    'vipHead',
    'vipTitle',
    'nowLevel',
    'nextLevelNeed',
    'ruleTitle',
    'vipLevel',
    'vipCondition',
    'firstSend',
    'weeklySend',
    'lastAllCoupon',
    'besides',
    'couponRatio',
    'backToPay',
    'quanGift',
    'quanGiftTips',
    'myVipScore',
    'couponMyQuan',
    'dzgVipRule1',
    'dzgVipRule2',
    'dzgVipRule3',
    'dzgVipRule4',
    'dzgVipRule5',
    'dzgVipRule6',
    'dzgVipRule7',
    'dzgVipRule8',
    'dzgVipRule9',
    'dzgVipRule10',
    'dzgVipRule11',
    'dzgVipRule12',
    'noPayWay',
    'dl3dtwVipRule1',
    'dl3dtwVipRule2',
    'dl3dtwVipRule3',
    'dl3dtwVipRule4',
    'dl3dtwVipRule5',
    'dl3dtwVipRule6',
    'dl3dtwVipRule7',
    'dl3dtwVipRule8',
    'dl3dtwVipRule9',
    'dl3dtwVipRule10',
    'dl3dtwVipRule11',
    'pleaseLang',
    'reference',
    'saveToNext',
    'cardNum',
    'expireTime',
    'CVV',
    'pleaseCard',
    'howToPay',
    'checkCard',
    'checkExpiryDate',
    'checkCVV',
    'addCard',
    'delete',
    'deleteCardTips',
    'confirmDelete',
    'cancelDelete',
    'checkAllCardMsg',
    'voucherLimitRegion',
    'leaveCreditPageTips',
    'sureToLeave',
    'continueToPay',
    'useDirectPay',
    'paypalFraudnetInfo',
    'morePurchaseWay',
    'purchaseNeed',

    'selectCountry',
    'areaLimitSwitchRegion',
    'areaLimitCurrentRegionCurrency',
    'areaLimitRegion',
    'areaLimitCurrency',
    'areaLimitNote',
    'areaLimitSwitchLimitation',
    'areaLimitPostSwitchCoupon',
    'areaLimitRemainingSwitches',
    'areaLimitNoRemainingSwitches',
    'areaLimitUnableToSwitchThisYear',
    'areaLimitCannotSwitch',
    'areaLimitNavigateToSwitch',
    'areaLimitConfirmSwitch',
    'areaLimitPreSwitchRegionCurrency',
    'areaLimitPostSwitchRegionCurrency',
    'areaLimitPostSwitchRestriction',
    'areaLimitUnusedZBitWarning',
    'areaLimitConfirm',
    'areaLimitCancel',
    'areaLimitInconsistencyWarning',
    'areaLimitPromptToSwitch',
    'areaLimitEnterZipCode',
    'areaLimitEnterInvalid',
    'areaLimitTaxRateTips',
    'areaLimitInfoCollect',
    'areaLimitConfirmRegion',
    'areaLimitContinuePay',
    'areaLimitSwitchLimitationTwice',
    'zipCodeSwitchZipCode',
    'zipCodeState',
    'zipCodeRate',
    'pay',
    'productSwitch'
  ]);
}
